export const NUMBERS = [
  { id: 'n1',  did: '+14155550100', location: 'San Francisco, CA', status: 'active',   platform: 'ms-teams',  trunk: 'VX-WEST-01',  callsToday: 47,  cnam: 'Acme Corp HQ'     },
  { id: 'n2',  did: '+14155550101', location: 'San Francisco, CA', status: 'active',   platform: 'ms-teams',  trunk: 'VX-WEST-01',  callsToday: 23,  cnam: 'Acme Corp HQ'     },
  { id: 'n3',  did: '+14155550102', location: 'San Francisco, CA', status: 'active',   platform: 'genesys',   trunk: 'VX-WEST-01',  callsToday: 102, cnam: 'Acme Corp Support' },
  { id: 'n4',  did: '+14155550103', location: 'San Francisco, CA', status: 'active',   platform: 'genesys',   trunk: 'VX-WEST-01',  callsToday: 88,  cnam: 'Acme Corp Support' },
  { id: 'n5',  did: '+12125550200', location: 'New York, NY',      status: 'active',   platform: 'ms-teams',  trunk: 'VX-EAST-01',  callsToday: 61,  cnam: 'Acme Corp NY'      },
  { id: 'n6',  did: '+12125550201', location: 'New York, NY',      status: 'active',   platform: 'ms-teams',  trunk: 'VX-EAST-01',  callsToday: 34,  cnam: 'Acme Corp NY'      },
  { id: 'n7',  did: '+12125550202', location: 'New York, NY',      status: 'active',   platform: 'nice-cxone',trunk: 'VX-EAST-01',  callsToday: 156, cnam: 'Acme Corp CC NY'   },
  { id: 'n8',  did: '+12125550203', location: 'New York, NY',      status: 'suspended',platform: null,        trunk: 'VX-EAST-01',  callsToday: 0,   cnam: 'Acme Corp NY'      },
  { id: 'n9',  did: '+13125550300', location: 'Chicago, IL',       status: 'active',   platform: 'webex',     trunk: 'VX-CENTRAL-01',callsToday: 29, cnam: 'Acme Corp CHI'     },
  { id: 'n10', did: '+13125550301', location: 'Chicago, IL',       status: 'active',   platform: 'webex',     trunk: 'VX-CENTRAL-01',callsToday: 18, cnam: 'Acme Corp CHI'     },
  { id: 'n11', did: '+14085550400', location: 'San Jose, CA',      status: 'porting',  platform: null,        trunk: null,          callsToday: 0,   cnam: 'Acme Corp SJC'     },
  { id: 'n12', did: '+14085550401', location: 'San Jose, CA',      status: 'porting',  platform: null,        trunk: null,          callsToday: 0,   cnam: 'Acme Corp SJC'     },
  { id: 'n13', did: '+17135550500', location: 'Houston, TX',       status: 'active',   platform: 'zoom-phone',trunk: 'VX-SOUTH-01', callsToday: 44,  cnam: 'Acme Corp HOU'     },
  { id: 'n14', did: '+17135550501', location: 'Houston, TX',       status: 'active',   platform: 'zoom-phone',trunk: 'VX-SOUTH-01', callsToday: 37,  cnam: 'Acme Corp HOU'     },
  { id: 'n15', did: '+16025550600', location: 'Phoenix, AZ',       status: 'active',   platform: 'five9',     trunk: 'VX-WEST-01',  callsToday: 211, cnam: 'Acme Corp PHX CC'  },
];

export const PLATFORMS = [
  { id: 'ms-teams',   name: 'Microsoft Teams',  type: 'UC', category: 'uc', color: '#2564cf', bg: '#1e3a6e', abbr: 'T',  status: 'connected', numbers: 6,  trunks: 2, endpoint: 'sip.pstnhub.microsoft.com' },
  { id: 'webex',      name: 'Webex Calling',    type: 'UC', category: 'uc', color: '#07c160', bg: '#0a3d22', abbr: 'W',  status: 'connected', numbers: 4,  trunks: 1, endpoint: 'sbc.webex.com' },
  { id: 'zoom-phone', name: 'Zoom Phone',       type: 'UC', category: 'uc', color: '#0e72ed', bg: '#0a2a52', abbr: 'Z',  status: 'connected', numbers: 2,  trunks: 1, endpoint: 'sbc.zoom.us' },
  { id: 'genesys',    name: 'Genesys Cloud',    type: 'CC', category: 'cc', color: '#ff4f1f', bg: '#3d1a0a', abbr: 'G',  status: 'connected', numbers: 2,  trunks: 1, endpoint: 'audiocodes.pure.cloud' },
  { id: 'nice-cxone', name: 'NICE CXone',       type: 'CC', category: 'cc', color: '#8b2be2', bg: 'var(--purple-bg)', abbr: 'N',  status: 'connected', numbers: 1,  trunks: 1, endpoint: 'sbc.niceincontact.com' },
  { id: 'five9',      name: 'Five9',            type: 'CC', category: 'cc', color: '#e53e3e', bg: '#3d1212', abbr: 'F9', status: 'connected', numbers: 1,  trunks: 1, endpoint: 'sbc.five9.com' },
  { id: 'avaya-axi',  name: 'Avaya Axies',      type: 'CC', category: 'cc', color: 'var(--warn)', bg: '#3d2206', abbr: 'AX', status: 'disconnected', numbers: 0, trunks: 0, endpoint: '' },
  { id: 'mitel',      name: 'Mitel MiCloud',    type: 'UC', category: 'uc', color: 'var(--cyan)', bg: '#0c2d3d', abbr: 'Mi', status: 'disconnected', numbers: 0, trunks: 0, endpoint: '' },
  { id: 'ringcentral',name: 'RingCentral',      type: 'UC', category: 'uc', color: '#f97316', bg: '#3d1f0a', abbr: 'RC', status: 'disconnected', numbers: 0, trunks: 0, endpoint: '' },
];

export const SBC_INSTANCES = [
  {
    id: 'sbc-west-01',
    name: 'SBC-WEST-01',
    model: 'AudioCodes Mediant 9000',
    location: 'AWS us-west-2',
    ip: '10.0.1.10',
    publicIp: '54.201.12.45',
    status: 'active',
    firmware: '7.40A.258',
    activeCalls: 34,
    maxCalls: 2000,
    cpuPct: 18,
    memPct: 42,
    sipTrunkStatus: 'up',
    uptime: '142d 6h 14m',
    trunks: ['VX-WEST-01'],
    platforms: ['ms-teams', 'webex', 'zoom-phone', 'genesys', 'five9'],
  },
  {
    id: 'sbc-east-01',
    name: 'SBC-EAST-01',
    model: 'AudioCodes Mediant 4000',
    location: 'AWS us-east-1',
    ip: '10.1.1.10',
    publicIp: '52.7.88.201',
    status: 'active',
    firmware: '7.40A.258',
    activeCalls: 22,
    maxCalls: 1000,
    cpuPct: 24,
    memPct: 55,
    sipTrunkStatus: 'up',
    uptime: '67d 11h 2m',
    trunks: ['VX-EAST-01'],
    platforms: ['ms-teams', 'nice-cxone'],
  },
  {
    id: 'sbc-central-01',
    name: 'SBC-CENTRAL-01',
    model: 'AudioCodes Mediant 4000',
    location: 'Azure centralus',
    ip: '10.2.1.10',
    publicIp: '40.122.210.33',
    status: 'active',
    firmware: '7.40A.252',
    activeCalls: 8,
    maxCalls: 1000,
    cpuPct: 9,
    memPct: 31,
    sipTrunkStatus: 'up',
    uptime: '23d 4h 55m',
    trunks: ['VX-CENTRAL-01'],
    platforms: ['webex'],
  },
];

export const TRUNKS = [
  { id: 'VX-WEST-01',    name: 'VX-WEST-01',    provider: 'Voxbone', region: 'West US',    capacity: 200, active: 34, status: 'up', sbc: 'sbc-west-01',    ip: '216.82.226.10' },
  { id: 'VX-EAST-01',    name: 'VX-EAST-01',    provider: 'Voxbone', region: 'East US',    capacity: 100, active: 22, status: 'up', sbc: 'sbc-east-01',    ip: '216.82.226.20' },
  { id: 'VX-CENTRAL-01', name: 'VX-CENTRAL-01', provider: 'Voxbone', region: 'Central US', capacity: 100, active: 8,  status: 'up', sbc: 'sbc-central-01', ip: '216.82.226.30' },
  { id: 'VX-SOUTH-01',   name: 'VX-SOUTH-01',   provider: 'Voxbone', region: 'South US',   capacity: 50,  active: 5,  status: 'up', sbc: 'sbc-west-01',    ip: '216.82.226.40' },
];

export const RECENT_CALLS = [
  { id: 'c1',  from: '+14155559001', to: '+14155550102', direction: 'inbound',  duration: '4:22', platform: 'genesys',    status: 'completed', time: '2 min ago' },
  { id: 'c2',  from: '+14155550101', to: '+12125559012', direction: 'outbound', duration: '1:08', platform: 'ms-teams',   status: 'completed', time: '4 min ago' },
  { id: 'c3',  from: '+12125559033', to: '+12125550202', direction: 'inbound',  duration: '7:41', platform: 'nice-cxone', status: 'completed', time: '6 min ago' },
  { id: 'c4',  from: '+13125559055', to: '+13125550300', direction: 'inbound',  duration: '0:12', platform: 'webex',      status: 'missed',    time: '9 min ago' },
  { id: 'c5',  from: '+16025550600', to: '+16025559011', direction: 'inbound',  duration: '12:03', platform: 'five9',     status: 'completed', time: '11 min ago' },
  { id: 'c6',  from: '+14155550100', to: '+14085559001', direction: 'outbound', duration: '3:17', platform: 'ms-teams',   status: 'completed', time: '15 min ago' },
  { id: 'c7',  from: '+17135559077', to: '+17135550500', direction: 'inbound',  duration: '2:55', platform: 'zoom-phone', status: 'completed', time: '18 min ago' },
  { id: 'c8',  from: '+12125550205', to: '+12125559001', direction: 'outbound', duration: '—',    platform: 'ms-teams',   status: 'failed',    time: '22 min ago' },
];

export const ROUTING_RULES = [
  { id: 'r1', name: 'HQ Main Lines',       pattern: '+1415555010X', platform: 'ms-teams',   priority: 1, action: 'route', active: true  },
  { id: 'r2', name: 'Support Queue West',  pattern: '+141555510[23]',platform: 'genesys',    priority: 1, action: 'route', active: true  },
  { id: 'r3', name: 'NY Office',           pattern: '+1212555020X', platform: 'ms-teams',   priority: 1, action: 'route', active: true  },
  { id: 'r4', name: 'NY Contact Centre',   pattern: '+121255502[23]',platform: 'nice-cxone', priority: 2, action: 'route', active: true  },
  { id: 'r5', name: 'Chicago Team',        pattern: '+1312555030X', platform: 'webex',      priority: 1, action: 'route', active: true  },
  { id: 'r6', name: 'Houston Remote',      pattern: '+1713555050X', platform: 'zoom-phone', priority: 1, action: 'route', active: true  },
  { id: 'r7', name: 'Phoenix CC',          pattern: '+1602555060X', platform: 'five9',      priority: 1, action: 'route', active: true  },
  { id: 'r8', name: 'Emergency Fallback',  pattern: '+1*',          platform: 'ms-teams',   priority: 99, action: 'failover', active: true },
];

export const ALERTS = [
  { id: 'a1', severity: 'warn',  msg: 'SBC-CENTRAL-01 firmware 2 versions behind (7.40A.252 → 7.40A.258)', ts: '1h ago' },
  { id: 'a2', severity: 'info',  msg: 'Port-in order PO-2024-0881 for +14085550400 in progress (FOC: 2026-05-24)', ts: '3h ago' },
  { id: 'a3', severity: 'warn',  msg: 'Number +12125550203 suspended — contact billing to restore', ts: '6h ago' },
  { id: 'a4', severity: 'info',  msg: 'Voxbone trunk VX-SOUTH-01 capacity upgraded from 30 to 50 channels', ts: '1d ago' },
];
